/*
 * @Author: daiqi@sogou-inc.com
 * @Date: 2022-02-24 18:18:08
 * @Description: 通用处理函数
 */

/**
 * 节流
 */
export function throttle(callback, delay) {
  let timer = null;
  let runTime = 0;
  return function (args) {
    if (timer) {
      return;
    }
    const distance = Date.now() - runTime;
    const self = this;

    const myCallback = function () {
      runTime = Date.now();
      window.clearTimeout(timer);
      timer = null;
      typeof callback === 'function' && callback.apply(self, args);
    };

    if (distance >= delay) {
      myCallback();
    } else {
      timer = setTimeout(myCallback, delay);
    }
  };
}

/**
 * 防抖
 */
export function debounce(callback, delay) {
  let timer = null;
  return function (args) {
    if (timer) {
      window.clearTimeout(timer);
      timer = null;
    }

    timer = window.setTimeout(() => {
      typeof callback === 'function' && callback.apply(self, args);
      window.clearTimeout(timer);
      timer = null;
    }, delay);
  };
}

